module.exports = __webpack_public_path__ + "media/icons/trophy-icon-218442eb.svg";